<template>
  <div class="profile__wrapper">
    <profile-top
      :photo="photo"
      :name="name"
      :position="position"
      :company="company"
    />
    <div class="profile-content full-size">
      <!-- ВРЕМЕННО: отладка push, уходит вместе с рубежом 2 -->
      <div
        v-if="isDevStand"
        class="row"
      >
        <div class="col-12">
          <push-debug-card />
        </div>
      </div>
      <div
        v-if="isBarcode"
        class="hot-link-panel"
      >
        <div class="row">
          <div class="col-12">
            <up-card>
              <div>
                <h4 class="m-0 text-center">{{ $t('userProfile.barcode_title') }}</h4>
                <svg
                  id="barcode"
                  class="profile-barcode"
                ></svg>
              </div>
            </up-card>
          </div>
        </div>
      </div>
      <div
        v-if="isHotPanel"
        class="hot-link-panel"
      >
          <div class="row g-2 justify-content-evenly">
              <div v-if="false" class="col-6">
                <up-card>
                  <div class="hot-link">
                    <i class="exu-mail-2" />
                    <span class="hot-link-text">{{ $t('userProfile.messages') }}</span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="{ path: '/chat' }"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
              <div v-if="isCardCreated !== null" class="col-6">
                <up-card>
                  <div class="hot-link">
                    <i class="exu-persone-card" />
                    <span class="hot-link-text">
                      {{ isCardCreated
                        ? $t('userProfile.my_card')
                        : $t('userProfile.create_card') }}
                    </span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="isCardCreated ? '/business-card/preview' : '/business-card/edit'"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
              <div v-if="isBusinessCard" class="col-6">
                <up-card>
                  <div class="hot-link">
                    <i class="exu-users" />
                    <span class="hot-link-text">{{ $t('userProfile.participants_cards') }}</span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="{ path: '/business-card/collection' }"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
              <!-- Во всю ширину: плитка идёт третьей, а при нечётном их числе
                   последняя переносится на свою строку и висела бы половинкой
                   по центру. -->
              <div v-if="canScan" class="col-12">
                <up-card>
                  <div class="hot-link hot-link--wide">
                    <i class="exu-scan" />
                    <span class="hot-link-text">{{ $t('userProfile.scanner') }}</span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="{ name: 'ScanerPage' }"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
          </div>
      </div>
    </div>
    <profile-rubrics :rubrics="userData.rubrics" />
    <div class="profile-content__wrapper">
      <div class="profile-content">
      </div>
    </div>
  </div>
</template>

<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import userMethods from '@/components/mixins/methodsUser';
import ExuBarcode from '@//components/mixins/barcodeMethods';
import businessCard from '@/components/mixins/methodsBusinessCard';
import { canUseScanner } from '@/components/scanner/config';
import ProfileRubrics from '@/components/shared/ProfileRubrics.vue';
// ВРЕМЕННО: отладка push, уходит вместе с рубежом 2
import PushDebugCard from '@/components/shared/PushDebugCard.vue';

export default {
  name: 'UserProfile',
  components: { ProfileRubrics, PushDebugCard },
  props: {
    id: {
      requared: true,
    },
    locale: {
      type: String,
    },
  },
  data() {
    return {
      userData: {
        type: Object,
        default: () => ({}),
      },
      isCardCreated: null,
    };
  },
  mixins: [appBaseNav, userMethods, ExuBarcode, businessCard],
  computed: {
    // ВРЕМЕННО: отладочная панель push живёт только на стенде. У клиента домен
    // в store другой, поэтому на боевом её не видно. Уходит вместе с рубежом 4
    isDevStand() {
      return this.$store.getters.apiDomain.includes('dev.expoup.ru');
    },
    name() {
      return this.userData.name || '';
    },
    position() {
      return this.userData.position || '';
    },
    company() {
      return this.userData.company || '';
    },
    photo() {
      return this.userData.photo || '';
    },
    isBarcode() {
      return !!this.userData.user_code;
    },
    barcode() {
      return this.userData.user_code;
    },
    isBusinessCard() {
      return this.$store.getters.isBusinessCard;
    },
    // Кому доступен сканер, решает его собственный конфиг: там же лежит будущая
    // проверка роли, и разъезжаться этим двум местам нельзя.
    canScan() {
      return canUseScanner(this.$store.getters.getUserRole);
    },
    // Условие перечисляет всё, что может оказаться в панели: плитка визиток
    // пропадает вместе с выключенным модулем, плитка сканера — по роли, и
    // панель прячется, только когда не осталось ни одной.
    isHotPanel() {
      return this.isBusinessCard || this.canScan;
    },
  },
  watch: {
    locale() {
      this.$store.commit('setPageTitle', this.$t('userProfile.header_title'));
    },
  },
  beforeCreate() {
    try {
      if (!this.$store.getters.isAuth) {
        this.$router.push({ name: 'loginView' });
      }
    } catch (e) {
      console.error(e);
    }
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('userProfile.header_title'));
    if (this.$store.getters.isAuth) {
      this.$emit('loading', true);
      this.loadCached();
      this.getUserProfile()
        .then((result) => {
          this.$emit('loading', false);
          this.userData = { ...result };
          return this.barcode;
        // })
        // .then((barcode) => {
        //   if (barcode) {
        //     this.createBarcode('barcode', barcode);
        //   }
        });
      if (this.isBusinessCard) {
        this.getMyBusinessCard()
          .then((data) => {
            this.isCardCreated = data.is_created;
          })
          .catch(() => {
            this.isCardCreated = false;
          });
      }
    }
  },
  updated() {
    if (this.isBarcode) {
      this.createBarcode('barcode', this.barcode);
    }
  },
  methods: {
    loadCached() {
      const jsonCachingProfile = localStorage.getItem('profile');
      if (jsonCachingProfile) {
        this.userData = JSON.parse(jsonCachingProfile);
        this.$emit('loading', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.profile {
  &__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  min-height: 100%;
  padding-bottom: 24px;
}
  &-content {
    &__wrapper {
      display: flex;
      width: 100%;
      max-width: 760px;
      margin: 0 auto;
      align-items: center;
      flex: 3 1 100%;
      align-self: stretch;
    }
  }

  &-barcode {
    width: 100%;
  }
}
.profile-content {
  display: flex;
  padding: 0px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  &.full-size {
    width: 100%;
    max-width: 760px;
    margin: 0 auto;
  }

  .hot-link-panel {
    width: 100%;
    color: #95969D;

    i {
      font-size: 36px;
    }
  }
  .hot-link {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
    padding: 0;

    @media(max-width: 450px) {
      & {
        padding: 24px 10px;
      }
    }

    .hot-link-text {

      display: block;
      font-size: 16px;
      line-height: 1.15em;
      color: #95969D;
      text-decoration: none;
      text-align: left;
    }

    // На половинной плитке space-evenly держит иконку и подпись рядом, а на
    // плитке во всю ширину растаскивает их по краям. Широкой нужна не
    // раздача свободного места, а пара по центру.
    &--wide {
      justify-content: center;
    }
  }

  .description-paragraph {
    color: #95969D;
    // font-family: Roboto;
    // font-size: 14px;
    text-align: justify;
    margin: 0;
  }
}
</style>
